export const MODAL_SHAREHOLDER_RESOURCE_NAME = 'modals/shareholder';
export const MODAL_TYPE_SHAREHOLDER = MODAL_SHAREHOLDER_RESOURCE_NAME;

export interface Shareholder {
  readonly hasShareholder: boolean;
}
